import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, ArrowUpRight } from "lucide-react";
import { company, nav, services } from "../mock";
import Logo from "./Logo";

const Footer = () => {
  return (
    <footer className="px-3 sm:px-5 pb-5">
      <div className="max-w-6xl mx-auto rounded-[28px] bg-[#1a1714] text-neutral-300 overflow-hidden">
        <div className="px-7 sm:px-12 pt-14 pb-10 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="bg-white/95 inline-flex rounded-xl px-3 py-2"><Logo /></div>
            <p className="mt-5 text-sm leading-relaxed text-neutral-400 max-w-xs">
              Your hassle-free cleaning partner across {company.area}.
            </p>
            <a href={company.phoneHref} className="mt-6 inline-flex items-center gap-2 text-white font-display text-xl font-semibold hover:text-[#ea731d] transition-colors">
              {company.phone}
            </a>
          </div>

          <div>
            <h4 className="text-white/60 font-semibold mb-4 text-xs uppercase tracking-[0.2em]">Pages</h4>
            <ul className="space-y-3 text-sm">
              {nav.map((n) => (
                <li key={n.path}>
                  <Link to={n.path} className="hover:text-[#ea731d] transition-colors">{n.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white/60 font-semibold mb-4 text-xs uppercase tracking-[0.2em]">Services</h4>
            <ul className="space-y-3 text-sm">
              {services.map((s) => (
                <li key={s.id}>
                  <Link to="/services" className="hover:text-[#ea731d] transition-colors">{s.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white/60 font-semibold mb-4 text-xs uppercase tracking-[0.2em]">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li><a href={`mailto:${company.email}`} className="flex items-center gap-3 hover:text-[#ea731d] transition-colors"><Mail size={16} className="text-[#ea731d]" /> {company.email}</a></li>
              <li><a href={company.phoneHref} className="flex items-center gap-3 hover:text-[#ea731d] transition-colors"><Phone size={16} className="text-[#ea731d]" /> {company.phone}</a></li>
            </ul>
            <Link to="/contact" className="mt-6 inline-flex items-center gap-1.5 bg-[#ea731d] hover:bg-[#d9640f] text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors">
              Get a quote <ArrowUpRight size={16} />
            </Link>
          </div>
        </div>

        <div className="px-7 sm:px-12 pb-8">
          <p className="text-xs text-neutral-500 leading-relaxed max-w-4xl">
            <span className="text-neutral-400 font-semibold">Areas we cover:</span> iClean NW provides commercial, office and industrial cleaning across Greater Manchester and the North West, including Manchester, Salford, Stockport, Trafford, Bolton, Bury, Oldham, Rochdale, Tameside, Wigan, Warrington and the surrounding areas. Services include contract cleaning, office and retail cleaning, end-of-tenancy and post-construction cleans, and grounds maintenance.
          </p>
        </div>

        <div className="px-7 sm:px-12 py-5 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-neutral-500">
          <p>© {new Date().getFullYear()} {company.fullName}. All rights reserved.</p>
          <p>Vetted · Trained · Fully Insured</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
